export const NOOP = () => {}

export const EMPTY_ARRAY = []
export const EMPTY_OBJECT = {}
